import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ConformidadesContent } from './components/ConformidadesContent';

export default function Conformidades() {
  return (
    <>
      <MainContent
        titulo='Conformidades'
        component={<ConformidadesContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}